import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import useLoginRoute from '../../../hooks/useLoginRoute';
import Button from '../Button';

const LoginFirstModalContent = ({ title = '' }) => {
  const { loginRoute } = useLoginRoute();
  const lang = useSelector(({ common }) => common?.language);
  const router = useRouter();

  const handleSignUp = async () => {
    localStorage.setItem('login_clicked', 1);
    router.push(loginRoute);
  };

  return (
    <div className='mx-auto flex max-w-[396px] flex-col items-center justify-center gap-4'>
      <p className='mb-0 mt-[8px] text-center text-[28px] font-bold text-[#2C2C2C]'>
        {title ? title : lang?.common?.please_create_an_account_first}
      </p>
      <Button variant='primary' onClick={handleSignUp}>
        {lang?.common?.sign_up}
      </Button>
      <p className='mb-0 mt-[8px] text-[#2C2C2C]'>
        {lang?.common?.already_have_an_account}?
        <span
          onClick={async () => {
            localStorage.setItem('login_clicked', 1);
            router.push(loginRoute);
          }}
          className='cursor-pointer font-bold text-high'
        >
          {lang?.common?.log_in}
        </span>
      </p>
    </div>
  );
};

export default LoginFirstModalContent;
